module.exports = __webpack_public_path__ + "images/TinyTacoTalking.9128b5432594de9b24d4.png";